import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { AddInvoiceApi } from "./InvoiceAction";
import { addCustomer, getCustomerData } from "../../AddDetails/AddCustomer/Customer.action";
import { getProductData } from "../../AddDetails/AddProduct/Product.action";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert, roundToTwoDecimals } from "../../../../../global/globalFunctions";
import { GetLevelAccountTypeApi } from "../LevelFour/LevelFourAction";
import _ from 'lodash'
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Select from "react-select";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import moment from "moment";


const AddInvoice = (props) => {
    const [inputField, setInputField] = useState([{
        item: "",
        quantity: 0,
        salePrice: 0,
        totalPrice: 0,
    }]);
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [typeId, setTypeId] = useState(2);
    const [typeName, setTypeName] = useState("Invoice Type 2");
    const [invoiceDate, setInvoiceDate] = useState(moment().format("YYYY-MM-DD"))
    const [manualInvoiceNumber, setManualInvoiceNumber] = useState("")
    const [remarks, setRemarks] = useState("")
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [customer, setCustomer] = useState("");
    const [customerCnic, setCustomerCnic] = useState();
    const [customerPhone, setCustomerPhone] = useState();
    const [customerAddress, setCustomerAddress] = useState("");
    const [balance, setBalance] = useState(0);
    const [accountTypeId, setAccountTypeId] = useState();
    const [accountTypeName, setAccountTypeName] = useState();


    function SaveInvoiceOne() {
        props.AddInvoiceApi({
            typeId: typeId,
            typeName: typeName,
            invoiceDate: invoiceDate,
            manualInvoiceNumber: manualInvoiceNumber,
            remarks: remarks,
            customerDetails: {
                customerId: customerId,
                customerName: customerName,
            },
            data: inputField,
        },
            showSuccessAlert,
            showErrorAlert
        );
        setTypeId(2)
        setCustomerId("")
        setCustomerName("")
        // setInvoiceDate("")
        setManualInvoiceNumber("")
        setRemarks("")
        setInputField([{
            item: "",
            quantity: 0,
            salePrice: 0,
            totalPrice: 0,
        }])
    }
    function SaveCustomer() {
        const customerData = {
            name: customer,
            phone: customerPhone,
            address: customerAddress,
            email: customerCnic,
            debitCreditId: accountTypeId,
            balance: Number(balance),
        };
        props.addCustomer(
            customerData,
            (message) => {
                // Success callback
                setCustomer("");
                setCustomerCnic("");
                setCustomerPhone("");
                setCustomerAddress("");
                handleCloseCustomerModal();
                props.getCustomerData();
                showSuccessAlert(message); // Show success message
            },
            (errorMessage) => {
                // Error callback
                showErrorAlert(errorMessage); // Show error message
            }
        );
    }

    let TypesArray = [{
        typeId: 1,
        typeName: "Invoice Type 1",
    },
    {
        typeId: 2,
        typeName: "Invoice Type 2",
    }];
    const handleChangeType = (selectedOption) => {
        setTypeId(selectedOption.value);
        setTypeName(selectedOption.label);
    };
    const GetTypeList = TypesArray.map((x) => {
        let data = { value: x.typeId, label: x.typeName };
        return data;
    });

    const handleChangeCustomer = (selectedOption) => {
        setCustomerId(selectedOption.value);
        setCustomerName(selectedOption.label);
    };
    const getCustomerList = !_.isEmpty(props.customerDataList) && props.customerDataList.map((x) => {
        let data = { value: x._id, label: x.name };
        return data;
    });

    const productList = props.productDataList.map((x) => {
        let data = { value: x._id, label: x.name };
        return data;
    });

    const handleChangeInvoiceOne = (e, index, type) => {
        const list = [...inputField];
        if (type === 'item') list[index]['item'] = e.target.value;
        if (type === 'quantity') list[index]['quantity'] = Number(e.target.value);
        if (type === 'salePrice') list[index]['salePrice'] = Number(e.target.value);
        if (type === 'quantity' || type === 'salePrice') list[index]['totalPrice'] = roundToTwoDecimals(list[index]['quantity'] * list[index]['salePrice']);
        setInputField(list);
    };
    const handleAddInput = () => {
        setInputField([...inputField,
        { item: "", quantity: 0, salePrice: 0, totalPrice: 0 },
        ]);
    };
    const handleRemoveInput = (index) => {
        const list = [...inputField];
        list.splice(index, 1);
        setInputField(list);
    };


    const handleChangeInvoiceTwo = (e, index, type) => {
        let z;
        if (type === "item") { z = _.find(props.productDataList, (x) => x._id == e.value); }
        const list = [...inputField];
        if (type === "productId") list[index]["productId"] = e.value;
        if (type === "item") {
            list[index]["productId"] = e.value;
            list[index]["item"] = e.label;
            list[index]["productBalance"] = Number(z.productBalance);
            list[index]["salePrice"] = Number(z.salePrice);
            list[index]["purchasePrice"] = Number(z.purchasePrice);
        }
        if (type === "salePrice") list[index]["salePrice"] = Number(e.target.value);
        if (type === "quantity") list[index]["quantity"] = Number(e.target.value);
        if (type === 'item' || type === 'quantity' || type === 'salePrice') { list[index]['totalPrice'] = roundToTwoDecimals(list[index]['salePrice'] * list[index]['quantity']); }

        setInputField(list);
    };

    const handleAddCustomer = () => {
        setShowCustomerModal(true);
    };
    const handleCloseCustomerModal = () => {
        setShowCustomerModal(false);
    };
    const handleChangeAccountType = (selectedOption) => {
        setAccountTypeId(selectedOption.value);
        setAccountTypeName(selectedOption.label);
    };
    const getAccountTypeList = !_.isEmpty(props.accountTypeList) && props.accountTypeList.map((x) => {
        let data = { value: x._id, label: x.account_type_name };
        return data;
    });

    useEffect(() => {
        props.setHeading("New Invoice");
        props.getCustomerData();
        props.getProductData();
        props.GetLevelAccountTypeApi();
    }, []);

    return (
        <>
            {props.isFetchingCustomer || props.isFetchingProduct || props.isAddingInvoice || props.isFetchingAccountType ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Invoice Type *</b></Form.Label>
                                    <Select
                                        placeholder="Select Invoice Type"
                                        onChange={handleChangeType}
                                        options={GetTypeList}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>


                        <div hidden={typeId === 1 ? false : true}> {/* INVOICE TYPE 1 */}
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="garana">
                                        <Form.Label><b>Invoice Date *</b></Form.Label>
                                        <Form.Control
                                            type="date"
                                            placeholder="Invoice Date"
                                            onChange={(e) => setInvoiceDate(e.target.value)}
                                            value={invoiceDate}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="garana">
                                        <Form.Label><b>Select Customer *</b></Form.Label>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    isDisabled={_.isEmpty(getCustomerList)}
                                                    placeholder="Select Customer"
                                                    onChange={handleChangeCustomer}
                                                    options={getCustomerList}
                                                    isClearable
                                                />
                                            </div>
                                            <Button
                                                title="Add Customer"
                                                variant="primary"
                                                onClick={handleAddCustomer}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 10px',
                                                    backgroundColor: '#81ABD3',
                                                }}
                                            >
                                                <AddIcon />
                                            </Button>
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="garana">
                                        <Form.Label><b>Manual Invoice Number</b></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Manual Invoice Number"
                                            onChange={(e) => setManualInvoiceNumber(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="garana">
                                        <Form.Label><b>Remarks</b></Form.Label>
                                        <Form.Control
                                            type="textarea"
                                            placeholder="Remarks"
                                            onChange={(e) => setRemarks(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {inputField.map((item, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <Row>
                                            <Col lg="1" md="1" xs="1">
                                                <Form.Group>
                                                    <Form.Label> <b>Sr No.</b> </Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        type="number"
                                                        placeholder="Sr No"
                                                        name="serial"
                                                        value={i + 1}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label><b>Item *</b></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Item"
                                                        name="item"
                                                        value={item.item}
                                                        onChange={e => handleChangeInvoiceOne(e, i, 'item')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>Quantity *</b></Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        placeholder="Quantity"
                                                        name="quantity"
                                                        value={item.quantity}
                                                        onChange={e => handleChangeInvoiceOne(e, i, 'quantity')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>Price *</b></Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        placeholder="Price"
                                                        name="salePrice"
                                                        value={item.salePrice}
                                                        onChange={e => handleChangeInvoiceOne(e, i, 'salePrice')}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>Total Price</b></Form.Label>
                                                    <Form.Control
                                                        style={{ backgroundColor: '#78bbd7', color: "black" }}
                                                        disabled
                                                        type="number"
                                                        placeholder="Total Price"
                                                        name="TotalPrice"
                                                        value={roundToTwoDecimals(item.totalPrice)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col style={{ marginTop: "30px" }}>
                                                {inputField.length - 1 == i && (
                                                    <Button
                                                        title="Click to Add Invoice"
                                                        onClick={handleAddInput}
                                                        style={{
                                                            float: "right",
                                                            color: "white",
                                                            backgroundColor: '#81ABD3',
                                                        }}
                                                    >
                                                        <AddIcon />
                                                    </Button>
                                                )}

                                                {inputField.length !== 1 && (
                                                    <Button
                                                        title="Click to Remove Invoice"
                                                        onClick={() => handleRemoveInput(i)}
                                                        style={{
                                                            float: "right",
                                                            color: "white",
                                                            backgroundColor: '#81ABD3',
                                                            marginRight: "10px",
                                                        }}
                                                    >
                                                        <RemoveIcon />
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </React.Fragment>

                                );
                            })}

                            <div className="sendDiv">
                                {_.isEmpty(customerId) || _.isEmpty(invoiceDate) || inputField.some(entry => !entry.item || entry.quantity <= 0 || entry.price <= 0) ? (
                                    <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                                ) : (
                                    <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveInvoiceOne}> SAVE </Button>
                                )}
                            </div>

                        </div>


                        <div hidden={typeId === 2 ? false : true}> {/* INVOICE TYPE 2 */}
                            <Row>
                                <Col>
                                    <Form.Group >
                                        <Form.Label><b>Invoice Date *</b></Form.Label>
                                        <Form.Control
                                            type="date"
                                            placeholder="Invoice Date"
                                            onChange={(e) => setInvoiceDate(e.target.value)}
                                            value={invoiceDate}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="garana">
                                        <Form.Label><b>Select Customer *</b></Form.Label>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    isDisabled={_.isEmpty(getCustomerList)}
                                                    placeholder="Select Customer"
                                                    onChange={handleChangeCustomer}
                                                    options={getCustomerList}
                                                />
                                            </div>
                                            <Button
                                                title="Add Customer"
                                                variant="primary"
                                                onClick={handleAddCustomer}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '6px 10px',
                                                    backgroundColor: '#81ABD3',
                                                }}
                                            >
                                                <AddIcon />
                                            </Button>
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="garana">
                                        <Form.Label><b>Manual Invoice Number</b></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Manual Invoice Number"
                                            onChange={(e) => setManualInvoiceNumber(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="garana">
                                        <Form.Label><b>Remarks</b></Form.Label>
                                        <Form.Control
                                            type="textarea"
                                            placeholder="Remarks"
                                            onChange={(e) => setRemarks(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {inputField.map((item, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3" controlId="garana">
                                                    <Form.Label><b>Select Product *</b> </Form.Label>
                                                    <Select
                                                        placeholder="Select Product"
                                                        name="item"
                                                        onChange={(e) => handleChangeInvoiceTwo(e, i, "item")}
                                                        options={productList}
                                                        isOptionDisabled={(option) => !_.isEmpty(_.find(inputField, (x) => x.productId == option.value))}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            {/* <Col>
                                                <Form.Group>
                                                    <Form.Label><b>Available Quantity *</b></Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        type="number"
                                                        placeholder="Available Quantity"
                                                        name="productBalance"
                                                        value={item.productBalance}
                                                    />
                                                </Form.Group>
                                            </Col> */}
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label><b>Sale Price *</b></Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        placeholder="Sale Price"
                                                        name="salePrice"
                                                        value={item.salePrice}
                                                        onChange={(e) => handleChangeInvoiceTwo(e, i, "salePrice")}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label><b>Quantity *</b></Form.Label>
                                                    <Form.Control
                                                        min={0}
                                                        type="number"
                                                        placeholder="Quantity"
                                                        name="quantity"
                                                        value={item.quantity}
                                                        onChange={(e) => handleChangeInvoiceTwo(e, i, "quantity")}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>Total Price</b></Form.Label>
                                                    <Form.Control
                                                        style={{ backgroundColor: '#78bbd7', color: "black" }}
                                                        disabled
                                                        type="number"
                                                        placeholder="Total Price"
                                                        name="TotalPrice"
                                                        value={roundToTwoDecimals(item.totalPrice)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col style={{ marginTop: "30px" }}>
                                                {inputField.length - 1 == i && (
                                                    <Button
                                                        title="Click to Add Invoice"
                                                        onClick={handleAddInput}
                                                        style={{
                                                            float: "right",
                                                            color: "white",
                                                            backgroundColor: '#81ABD3',
                                                        }}
                                                    >
                                                        <AddIcon />
                                                    </Button>
                                                )}

                                                {inputField.length !== 1 && (
                                                    <Button
                                                        title="Click to Remove Invoice"
                                                        onClick={() => handleRemoveInput(i)}
                                                        style={{
                                                            float: "right",
                                                            color: "white",
                                                            backgroundColor: '#81ABD3',
                                                            marginRight: "10px",
                                                        }}
                                                    >
                                                        <RemoveIcon />
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>

                                    </React.Fragment>
                                );
                            })}

                            <div className="sendDiv">
                                {_.isEmpty(customerId) || _.isEmpty(invoiceDate) || inputField.some(entry => entry.quantity <= 0 || entry.salePrice <= 0) ? (
                                    <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                                ) : (
                                    <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveInvoiceOne}> SAVE </Button>
                                )}
                            </div>

                        </div>


                        <Modal show={showCustomerModal} onHide={handleCloseCustomerModal} centered size="lg">
                            <Modal.Header closeButton>
                                <Modal.Title>Add New Customer</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="garana">
                                            <Form.Label><b>Customer Name *</b></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Customer Name"
                                                onChange={(e) => setCustomer(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="garana">
                                            <Form.Label><b>Outstanding Balance *</b></Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={balance}
                                                placeholder="Outstanding Balance"
                                                min={0}
                                                onChange={(e) => { setBalance(e.target.value) }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="garana">
                                            <Form.Label><b>Balance Type *</b></Form.Label>
                                            <Select
                                                placeholder="Balance Type"
                                                onChange={handleChangeAccountType}
                                                options={getAccountTypeList}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="garana">
                                            <Form.Label><b>Customer Phone </b></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Customer Phone"
                                                onChange={(e) => setCustomerPhone(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="garana">
                                            <Form.Label><b>Customer Email </b></Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Customer Email"
                                                onChange={(e) => { setCustomerCnic(e.target.value); }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="garana">
                                            <Form.Label><b>Customer Address </b></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Customer Address"
                                                onChange={(e) => setCustomerAddress(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                                {_.isEmpty(customer) || _.isEmpty(accountTypeName) ? (
                                    <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE CUSTOMER</Button>
                                ) : (
                                    <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveCustomer}> SAVE CUSTOMER </Button>
                                )}
                            </Modal.Footer>
                        </Modal>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        addCustomer: (data, showSuccessAlert, showErrorAlert) => dispatch(addCustomer(data, showSuccessAlert, showErrorAlert)),
        AddInvoiceApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddInvoiceApi(data, showSuccessAlert, showErrorAlert)),
        getCustomerData: () => dispatch(getCustomerData()),
        getProductData: () => dispatch(getProductData()),
        GetLevelAccountTypeApi: () => dispatch(GetLevelAccountTypeApi()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingInvoice: state.InvoiceReducer.isAddingInvoice,
    customerDataList: state.CustomerReducer.customerDataList,
    isFetchingCustomer: state.CustomerReducer.isFetchingCustomer,
    productDataList: state.ProductReducer.productDataList,
    isFetchingProduct: state.ProductReducer.isFetchingProduct,
    isFetchingAccountType: state.LevelFourReducer.isFetchingAccountType,
    accountTypeList: state.LevelFourReducer.accountTypeList,
});


export default connect(mapStateToProps, mapDispatchToProps)(AddInvoice);